import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex w-full items-center justify-center pt-8 gap-1" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = ["onClick"]

import { ref, computed, watch } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaginationControl',
  props: {
  selectedPage: {
    type: Number,
    default: 1,
  },
  perPage: {
    type: Number,
    default: 50,
  },
  gap: {
    type: Number,
    default: 1,
  },
  totalPages: {
    type: Number,
    default: 0,
  },
},
  emits: ["setPage"],
  setup(__props, { emit }) {

const props = __props;





const currentPage = ref<number>(1);

const visiblePages = computed(() => {
  const total: number = +props.totalPages;
  const current: number = +currentPage.value;

  if (total <= 30) {
    return Array.from({ length: total }, (_, index) => index + 1);
  }

  let start: number, end: number;

  if (current <= 15) {
    start = 1;
    end = 30;
  } else if (current >= total - 14) {
    start = total - 29;
    end = total;
  } else {
    start = current - 14;
    end = current + 15;
  }

  return Array.from({ length: end - start + 1 }, (_, index) => start + index);
});

const goToPage = (page: number) => {
  if (page >= 1 && page <= props.totalPages) {
    currentPage.value = page;
    emit("setPage", currentPage.value);
  }
};
const previousPage = () => {
  if (currentPage.value > 1) {
    currentPage.value--;
    emit("setPage", currentPage.value);
  }
};
const nextPage = () => {
  if (currentPage.value < props.totalPages) {
    currentPage.value++;
    emit("setPage", currentPage.value);
  }
};
const lastPage = () => {
  if (currentPage.value < props.totalPages) {
    currentPage.value = props.totalPages;
    emit("setPage", currentPage.value);
  }
};
const firstPage = () => {
  currentPage.value = 1;
  emit("setPage", currentPage.value);
};

watch(props, () => {
  currentPage.value = props.selectedPage;
});

return (_ctx: any,_cache: any) => {
  const _component_mdicon = _resolveComponent("mdicon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_mdicon, {
      class: "rounded-full cursor-pointer bg-[#008b4e] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50",
      name: "chevron-double-left",
      disabled: currentPage.value === 1,
      onClick: firstPage
    }, null, 8, ["disabled"]),
    _createVNode(_component_mdicon, {
      class: "rounded-full cursor-pointer bg-[#008b4e] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50",
      name: "chevron-left",
      disabled: currentPage.value === 1,
      onClick: previousPage
    }, null, 8, ["disabled"]),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visiblePages.value, (page) => {
        return (_openBlock(), _createElementBlock("span", {
          key: page,
          class: _normalizeClass([
          'cursor-pointer',
          'px-3',
          {
            'bg-[#008B4E] text-white font-bold': currentPage.value == page,
            'bg-[#F0F0F0] text-[#969393] ': currentPage.value !== page,
          },
        ]),
          onClick: ($event: any) => (goToPage(page))
        }, _toDisplayString(page), 11, _hoisted_3))
      }), 128))
    ]),
    _createVNode(_component_mdicon, {
      class: "rounded-full cursor-pointer bg-[#008b4e] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50",
      name: "chevron-right",
      disabled: currentPage.value === __props.totalPages,
      onClick: nextPage
    }, null, 8, ["disabled"]),
    _createVNode(_component_mdicon, {
      class: "rounded-full cursor-pointer bg-[#008b4e] text-white hover:bg-primary-green/50 focus:bg-primary-green/hover:bg-primary-green/50",
      name: "chevron-double-right",
      disabled: currentPage.value !== __props.totalPages,
      onClick: lastPage
    }, null, 8, ["disabled"])
  ]))
}
}

})